import type {AxiosError} from "axios";
import type {AlertColor} from "@mui/material/Alert";

export const SESSION_STORAGE_PREFIX = 'auth.v2.';

export type AuthProvider = 'auth0' | 'front_egg';

export type MithraAuthToken = {
    access_token: string
    refresh_token: string
    provider: AuthProvider
}

/**
 * Verify a Mithra API Response token
 * @param err
 */
export function isTokenExpired(err: AxiosError<any>) {
    if (err.response) {
        const resp = err.response;
        if (resp.status === 401 && resp.data.code === 'token_not_valid') {
            return true;
        }
    }
    return false;
}

export function isAuthenticationProvider(provider: string | null): provider is AuthProvider {
    if (!provider) return false;
    return ['auth0', 'front_egg'].includes(provider);
}

export type AlertMsg = undefined | { msg: string, severity: AlertColor };
